import { PinFlowScreen } from '../../components/common/PinFlowScreen';

export const SetPinScreen: React.FC = () => (
  <PinFlowScreen type="set" titleKey="settings.lockScreen.setPin" />
);
